import AssociesController from './associes.controller';

export default {
    template: require('./associes.tpl.html'),
    controller: AssociesController
};
